import * as React from "react";

import { AppTextArea } from "../../../ui-foundation/core";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
  return (
    <AppTextArea
      className={className}
      ref={ref as React.Ref<any>}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
